import { Component, OnInit, ViewChild, EventEmitter, Output, OnDestroy, AfterViewInit, ElementRef } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { LoginCognitoCallback, LoggedInCallback } from "../../../services/utils/cognito.service";
import { TranslateService } from '@ngx-translate/core';
import { Logger } from '../../../services/utils/logger'
import { NgRedux, select } from '@angular-redux/store';
import { IAppState } from '../../../services/utils/state-management/store';
import { RESET_REGISTRATION } from '../../../services/utils/state-management/actions';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserManagement } from "../../../services/utils/state-management/action-classes";
import { IForgotPassword, IUser } from "../../../services/utils/state-management/types";
import { Utility, spaceCheck } from "../../../services/utils/utility";
import { LoggingLevel } from "../../../services/utils/logging-level";
import { ComponentCanDeactivate } from "../../../guards/deactivate/ComponentCanDeactivate";
import { SignupOptionsModalComponent } from '../../register/signup-options-modal/signup-options-modal.component';
import { CookieService } from 'ngx-cookie-service';
import { FederatedManagementService } from "../../../services/federated-management.service";
import { UserProfileService } from "../../../services/user-profile.service";
import { ForgotPasswordService } from "../../../services/forgot-password.service";
import { DataShareService } from "../../../services/data-share.service";
import { ApiRequestService } from "src/app/services/api-client/api-requests.service";
import { Constants } from "src/app/services/utils/Constants";
import apiConfig from "src/app/services/api-client/api-config";
import { ResponseHandlerService } from "src/app/services/utils/response-handler.service";
import { Config } from "src/app/services/utils/Config";
import { LanguageChangeCallback, LanguageChangeService } from "src/app/services/language-change.service";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { CommonService } from "src/app/services/common.service";
import { LoaderService } from "src/app/services/loader.service";
import { UserLoginService } from "src/app/services/user-login.service";


@Component({
  selector: 'consumer-portal-login',
  templateUrl: './login.html',
  styleUrls: ['./login.css', '../../../../assets/css/ng-otp.css'],
})


export class LoginComponent extends ComponentCanDeactivate implements LoggedInCallback, LanguageChangeCallback, OnInit, OnDestroy, AfterViewInit {

  @Output() onError = new EventEmitter<any>();
  @ViewChild('mailfocus') mailFocus: ElementRef;

  session: any;
  loginForm: FormGroup;
  loginVerifyForm: FormGroup;
  user: IUser;
  choice = '';
  medium = 'phone';
  availableMediums: string[] = [];
  email= "";
  isLoginPristine = true;

  emailError = {
    divClass: '',
    req: false,
    invalid: false
  };
  codeError = {
    divClass: '',
    req: false
  };
  passwordError = {
    divClass: '',
    req: false
  };

  errorMessage: string = '';
  successMessage: string = '';
  step = 'login';
  isPhoneVerified = false;
  image: string;

  hidePass: boolean = true;
  lastTwoDigitsOfPhone: any;

  //ng-otp-input
  showOtpComponent = true;
  ngconfig = Utility.getNgxOtpConfigObject();


  federatedIdentities = Config.FEDERATED_IDENTITIES;

  userBrand: string;
  securityCodePaste: string;
  securityCode: string;
  securityCondition: boolean = false;
  isVerified: boolean = false;
  otpError: boolean = false;
  isLoaderActive: boolean = false;
  isLogin: boolean = false;
  googleFederation: boolean;
  appleFederation: boolean;
  config: Object;
  securityQuestionsFlag: any;
  forgotPasswordFlag: boolean;
  modalRef: BsModalRef;

  invalidUserPass: boolean = false;


  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public userService: UserLoginService,
    public federatedService: FederatedManagementService,
    public translate: TranslateService,
    public ngRedux: NgRedux<IAppState>,
    public apiService: ApiRequestService,
    public formBuilder: FormBuilder,
    private logger: Logger,
    public userManagementService: UserManagement,
    private utility: Utility,
    private modalService: BsModalService,
    public cookieService: CookieService,
    public userProfileService: UserProfileService,
    public forgotPasswordService: ForgotPasswordService,
    public responseHandler: ResponseHandlerService,
    private dataservice: DataShareService,
    private languageService: LanguageChangeService,
    private commonService: CommonService,
    public loaderService: LoaderService,
  ) {
    super();
    this.userProfileService.getUserData().subscribe(data => {
      this.isVerified = data.isVerified;
      this.user = data.user;
    });
    let configObject = JSON.parse(localStorage.getItem('config'));
    this.googleFederation = configObject && configObject.Feature.GoogleFederation;
    this.appleFederation = configObject && configObject.Feature.AppleFederation;
    this.securityQuestionsFlag = configObject && configObject.Feature.SecurityQuestions
  }


  ngAfterViewInit() {
    this.mailFocus.nativeElement.focus();
  }

  canDeactivate() {
    const rawState = localStorage.getItem('state');
    this.config = rawState ? JSON.parse(rawState) : {};
    // \this.config = JSON.parse(localStorage.getItem('state') || '');
    if (this.config['userObject'] && !this.config['userObject']['phoneActive']) {
      return false;
    } else if (this.step === 'login' || this.step === '') {
      return true;
    } else {
      return false;
    }
  }


  initLoginForm() {
    const cookieEmail = this.cookieService.get('email');
    this.availableMediums = [];

    this.loginForm = this.formBuilder.group({
      loginEmail: [cookieEmail || null, [Validators.required, Validators.pattern("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$")]],
      loginPassword: [null, Validators.required],
      rememberMe: cookieEmail ? true : false
    });
  }

  get f() {
    return this.loginForm.controls;
  }

  initVerifyForm() {
    this.securityCode = "";
    this.loginVerifyForm = this.formBuilder.group({
      securityCode: ["", Validators.required]
    });
  }

  ngOnInit() {
    this.userBrand = localStorage.getItem("userBrand");
    this.isLogin = window.location.href.endsWith('login');
    localStorage.removeItem('PhoneVerified');
    //Reset flow key
    localStorage.removeItem('FLOW');
    // adding clearing of session and localstorage for if someone abandons the federation flow, their token is not cleared
    // when canDeactivate returns false, removed the user and bring them on login page. In add a phone page user save in storage and not navigate to login page when click on logo
    if (this.ngRedux.getState().userObject === null || this.canDeactivate() === false) {
      sessionStorage.clear();
      Object.keys(localStorage).map(key => {
        if (key.startsWith('CognitoIdentityServiceProvider')) {
          localStorage.removeItem(key);
        }
      })
    }
    // error message in case of federated user does not exist in system
    let federatedUserErrorMessage = this.ngRedux.getState().errorMessage;
    if (federatedUserErrorMessage) {
      this.invalidUserPass = false;
      this.errorMessage = federatedUserErrorMessage
    }
    const queryParamStep = this.route.snapshot.queryParams['step'];
    const FederatedStep = Config.PROVIDERS.FEDERATED;
    if (queryParamStep === FederatedStep) {
      this.step = '';
    }
    else {

      this.errorMessage = this.utility.getErrorMessage();
      this.successMessage = this.utility.getSuccessMessage();
      this.ngRedux.dispatch({ type: RESET_REGISTRATION });

    }
    this.dataservice.currentValue.subscribe((value) => {
      if (value.error) {
        this.translate.get('REGISTRATION.EMAIL_VERIFICATION.ERROR.ALREADY_EXIST').subscribe(value => this.errorMessage = value);
      }
    })
    Utility.focusLogo();
    this.initLoginForm();
    this.initVerifyForm();


    this.logger.log(LoggingLevel.DEBUG, "home", "Checking if the user is already authenticated. If so, then redirect to the secure site");
    // this.image = './../../../../assets/images/login/bg' + (Math.floor((Math.random() * 100)) % 8 + 1) + '.jpg';
    this.image = './../../../assets/images/landing/Rectangle_794.jpg';
    this.userService.isAuthenticated(this);
  }

  orientationChangeHandler = () => {
    if (screen.orientation.type == "landscape-primary" && screen.orientation.angle != 0)
      document.body.classList.remove("main-class");
    else
      document.body.setAttribute('class', 'main-class');
  }

  ngOnDestroy() {
    // adding main class to body to hide overflow
    document.body.classList.remove("main-class");
  }


  onChanges($event) {
    // HALOC-3955: Add this check for email input field,
    // signup modal will open on second click, 
    // at first click it will check the validations on the field.
    if (this.loginForm.pristine) {
      return;
    }
    this.isLoginPristine = false;
    // if ($event == null || $event.target.id === 'loginEmail') {
    //   if (!this.loginForm.controls['loginEmail'].valid) {
    //     this.emailError.divClass = 'has-error';
    //     if (this.loginForm.controls['loginEmail'].errors['required']) {
    //       this.emailError.req = true;
    //       this.emailError.invalid = false;
    //     } else {
    //       this.emailError.req = false;
    //       this.emailError.invalid = true;
    //     }
    //   } else {
    //     this.emailError.divClass = 'has-success';
    //     this.emailError.req = false;
    //     this.emailError.invalid = false;
    //   }
    // }
    // if ($event == null || $event.target.id === 'loginPassword') {
    //   if (!this.loginForm.controls['loginPassword'].valid) {
    //     this.passwordError.divClass = 'has-error';
    //     this.passwordError.req = true;
    //   } else {
    //     this.passwordError.divClass = 'has-success';
    //     this.passwordError.req = false;
    //   }
    // } else if ($event.target.id === 'securityCode') {
    //   if (!this.loginVerifyForm.controls['securityCode'].valid) {
    //     this.codeError.divClass = 'has-error';
    //     this.codeError.req = true;
    //   } else {
    //     this.codeError.divClass = 'has-success';
    //     this.codeError.req = false;
    //   }
    // }
  }

  goToHome() {
    this.router.navigate(['/securehome']);
  }

  onRegister() {
    /* this.dialogService.addDialog(SignupOptionsModalComponent, {},
      { closeByClickingOutside: true }).subscribe((isConfirmed) => {
        this.userManagementService.removeUser();
      }); */

    this.emailError.invalid = false
    this.emailError.req = false
    // Reset the form instead of reinitializing
    // this.loginForm.reset();

    const initialState = {
      invalidEmail: this.emailError.invalid,
      requireEmail: this.emailError.req,
      login: this.loginForm
    }
    localStorage.setItem('PROVIDER', Config.PROVIDERS.FEDERATED);
    this.modalRef = this.modalService.show(SignupOptionsModalComponent,
      { initialState: initialState, backdrop: Constants.MODAL_CONFIG.backdrop, class: 'signup-options' });
    if (this.modalRef?.content?.event) {  // Ensure event exists
    this.modalRef.content.event.subscribe(confirmedData => {
      if (confirmedData) {
        this.loginForm.controls['loginEmail'].markAllAsTouched();
        this.onChanges(null);
      }
    });
    }
  }

  onRegisterPage() {
    this.router.navigate(['home/register']);
  }

  onLogin() {
    this.successMessage = null;
    if (!this.loginForm.valid) {
      this.onChanges(null);
      return;
    }
    this.errorMessage = null;

    this.userService.authenticate({
      username: this.loginForm.get("loginEmail").value,
      password: this.loginForm.get("loginPassword").value
    }).subscribe({
      next: async (res) => {
        this.handleMFAStep(res);
      },
      error: (err) => {
        this.errorHandler(err.error.message || err.error.error.message);
      }
    });
  }

  onResendCode(resend=true) {
    this.otpError = false;
    this.errorMessage = null;
    this.resetOTP();
    const email = this.loginForm.get("loginEmail").value
    this.userService.resendCode({session: this.session,username: email,medium: this.choice})
      .subscribe({
        next: (res) => {
            this.handleMFAStep(res);
            this.translate.get(resend ? 'HOME.ERROR.CODE_RESEND' : 'HOME.ERROR.CODE_SEND').subscribe(value => {
              this.errorMessage = value
          });
        },
        error: (err) => {
          this.errorHandler(err.error.message || err.error.error.message);
          this.loaderService.isLoading.next(false);
        }
      });
  }

  onSendCodeToEmail(resend=false) {
    this.choice = "email";
    this.onResendCode(resend);
  }

  onSendCodeToPhone(resend=false) {
    this.choice = "phone";
    this.onResendCode(resend);
  }

  onVerifyCode() {
    this.errorMessage = null;
    this.isLoaderActive = true;
    this.userService.verifyCode({
      session: this.session,
      username: this.loginForm.get("loginEmail").value,
      password: this.loginForm.get("loginPassword").value,
      medium: this.choice,
      code: this.securityCode.trim()})
      .subscribe({
        next: (res) => {
          this.handleMFAStep(res);
        },
        error: (err) => {
          this.loaderService.isLoading.next(false);
          this.errorHandler(err.error.message || err.error.error.message);
        }
      });
  }

  //ng-otp-input
  handleFillEvent(value: string): void {
    this.securityCodePaste = value;
    if (this.securityCodePaste.length === 6 && !this.securityCondition) {
      this.securityCode = this.securityCodePaste;
      this.securityCondition = true;
      this.onVerifyCode();
    }
  }

 
// Update resetOTP to only be called explicitly
resetOTP() {
  this.showOtpComponent = false;
  this.securityCodePaste = '';
  this.securityCode = '';
  this.securityCondition = false;
  setTimeout(() => {
    this.showOtpComponent = true;
  }, 0);
}

  handleMFAStep(resp : any){
    this.isLoaderActive = false;
    if (resp.challenge || resp.challengename) {
      this.step = "code";
      if(resp?.medium) {
        this.availableMediums = [...resp.medium];
      }
      const medium = this.availableMediums[0];
      this.choice = this.choice || medium;
      this.medium = this.choice || medium;

      this.session = resp.session;
      this.initVerifyForm();
      const isPhoneVerified = String(resp.isphoneverified).toLowerCase() === "true";
      if (isPhoneVerified) {
        this.isPhoneVerified = true;
        this.lastTwoDigitsOfPhone = resp.phonenumbersuffix;
      }
      else {
        this.isPhoneVerified = false;
      }
      if (resp.error) {
        this.otpError = true;
        this.errorHandler(resp.error.message);
        // Only reset on error
        this.securityCondition = false;
        this.resetOTP();
      }
    }
    else {
      this.commonService.storeRegionTokens(resp, this.loginForm.get("loginEmail").value, false);
      this.getUserProfileData()
    }
  }

  errorHandler(message: string) {
    // Invalid session for the user.
    this.invalidUserPass = false;
    this.isLoaderActive = false;
    this.loaderService.isLoading.next(false);
    if (message === 'User is not confirmed.') {
      this.router.navigate(['/home/confirmRegistration', this.loginForm.get("loginEmail").value]);
    } else if (message === 'User needs to set password.') {
      this.router.navigate(['/home/newPassword']);
    } else if (message.indexOf(Constants.ERROR_CODES.CODE_VERIFY_LIMIT_EXCEED) > -1) {
      this.isLoginPristine = true;
      this.translate.get('LOGIN.ERROR.RETRIES_EXCEEDED').subscribe(value => this.errorMessage = value);
      this.initLoginForm();
      this.step = "login"
    } else if (message.indexOf("Invalid session for the user.") > -1) {
       this.initLoginForm()
      this.translate.get('LOGIN.ERROR.SESSION_TIMEOUT').subscribe(value => this.errorMessage = value);
      this.step = "login"
    } else if(message == "Invalid username, code or session"){
      this.translate.get('HOME.ERROR.INCORRECT_CODE').subscribe(value => this.errorMessage = value);
    }
     else if(message == "Incorrect username or password." || message == "User does not exist."){
      this.invalidUserPass = true;
      this.translate.get('LOGIN.ERROR.INCORRECT_USERNAME_AND_PASSWORD').subscribe(value => this.errorMessage = value);
    }
    else {
      this.invalidUserPass = true;
      this.translate.get('LOGIN.ERROR.INCORRECT_USERNAME_AND_PASSWORD').subscribe(value => this.errorMessage = value);
    }
  }

  getUserProfileData(){
        this.apiService.callApi(Constants.API_METHODS.GET, apiConfig.me.uri, null).subscribe({
        next: (res) => {
          if (res && res.data && res.data.length > 0) {
            // HALOC-3023: Setting User Preferred Language After Login Success
            const preferredLanguage = this.ngRedux.getState().preferredLanguage;
            this.languageService.updateUserLanguage(true, preferredLanguage, this);
            res.data[0]['preferredlanguage'] = preferredLanguage;
            this.user = this.userManagementService.parseUserObjectAndDispatch(res.data[0]);
            if (this.user.phoneActive) {
              // Checking if the remember me value is true or false
              // if the value is "true" a cookie with name email will be saved in cookies
              if (this.loginForm.controls['rememberMe'].value === true) {
                document.cookie = "email=" + this.user.email + "; max-age=" + Config.COOKIE_MAX_AGE + "; SameSite=Lax; secure";
              }
              else {
                document.cookie = "email=;max-age=";
              }
              this.router.navigate(['/securehome']);
            } else {
              this.userManagementService.removeUserPhoneNumber();
            }
            // localstorage the user email if checked
            // this.router.navigate(['/securehome']);

            this.step = '';
          }
          else {
            if (res && res['type'] === Constants.ERROR_CODES.RESOURCE_NOT_FOUND) {
              //user not found, proceed to signup
              this.userManagementService.removeUser();
              this.router.navigate(['/home/register']);
            }
            else {
              this.router.navigate(['/home']);
            }
          }

        },
        error: (err) => {
          let data = this.responseHandler.parseErrorResponseV2(err);

        },
      })
  }


  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (isLoggedIn) {
      this.user = this.userManagementService.getUser();
      if (this.user) {
        if (this.user.phoneActive) {
          this.router.navigate(['/securehome']);
        } else {
          this.step = '';
        }
      }
    }
  }

  forgotPassword() {
    let forgotPassword: IForgotPassword = this.forgotPasswordService.getForgotPasswordObject();
    forgotPassword.step = 0;
    forgotPassword.email = this.loginForm.get("loginEmail").value && this.loginForm.get("loginEmail").value.toLowerCase();
    forgotPassword.verificationType = this.medium;
    forgotPassword.phoneNumber = null;
    forgotPassword.secretQuestions = null;
    forgotPassword.secretAnswer = null;
    forgotPassword.verificationCode = null;
    forgotPassword.phoneActive = true;
    this.forgotPasswordService.updateForgotPasswordObject(forgotPassword);
    if (this.securityQuestionsFlag) {
      if (this.loginForm.controls['loginEmail'].valid) {
        this.forgotPasswordService.getSecurityQuestions(this.loginForm.get("loginEmail").value.toLowerCase(), this);
        this.router.navigate(["/forgotPassword"]);
      }
    } else {
      this.sendForgotPasswordCode();
    }
    if (this.loginForm.get("loginEmail").value === '' || null) {
      this.forgotPasswordFlag = true;
    }
  }

  onEmailEnter() {
    this.forgotPasswordFlag = false;
  }

  sendForgotPasswordCode() {
    this.forgotPasswordService.callApiToSendCode('phone', this);
  }

  sendVerifiactionCodeFailure() {
    this.translate.get('FORGOT_PASSWORD.ENTER_VERIFICATION_CODE.ERROR.COMMON').subscribe((value) => {
      this.onError.emit(value);
    })

  }

  sendVerifiactionCodeErrorResponse(res) {
    // res = this.responseHandler.getErrorMessage('FORGOT_PASSWORD.ENTER_VERIFICATION_CODE.ERROR', res);
    let errMessg = '';
    let errorMessage = '';
    for (errMessg of res) {
      errorMessage += errMessg + ', ';
    }
    errorMessage = errorMessage.substring(0, errorMessage.length - 2);
    if (errorMessage.slice(-1) !== ".") {
      errorMessage += ".";
    }
    this.onError.emit(errorMessage);
    this.errorMessage = errorMessage
  }

  sendVerifiactionCodeSuccess() {
    this.router.navigate(["/forgotPassword"]);
    this.translate.get('FORGOT_PASSWORD.SELECT_VERIFICATION_TYPE.RESEND_CODE.SUCCESS').subscribe((value) => {
      this.onError.emit(value);
    })

  }

  logout() {
    this.userService.logout();
    window.location.reload();
  }

  updateCallback() {
    // this.router.navigate(["/securehome"]);
  }

  togglePasswordField() {
    this.hidePass = !this.hidePass;
  }

  isPhoneMediumAvailable(): boolean {
    return this.availableMediums.includes('phone');
  }

  // onGoogleLogin() {
  //   localStorage.removeItem('FLOW');
  //   const url = this.googleservice.getGoogleLoginUrl();
  //   window.open(url, "_self");

  // }

  onFederatedLogin(value: string) {
    localStorage.removeItem('FLOW');
    const url = this.federatedService.getFederatedLoginUrl(value);
    window.open(url, "_self");
  }

  onSuccessSendCode() {
    if (this.user && this.user.phoneActive) {
      this.router.navigate(['/securehome']);
    }
  }

  onFailure() {
    return;
  }

}